<template>
<div>

  <h1>Rooms of <router-link v-if="room.accommodation" :to="{ name: 'accommodation-edit', params: { id: room.accommodation_id }}">{{ room.accommodation.accommodation_name }}</router-link></h1>

  <div class="box">
    <form class="form" v-on:submit.prevent="updateRoom">
      <div class="row p-2">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-3">
                  <div>
                    <label for="name">Name</label>
                    <input type="text" required id="name" v-model="room.name">
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <label for="board-basis">Board basis</label>
                    <input type="text" required id="board-basis" v-model="room.board_basis">
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <label for="occupancy">Occupancy</label>
                    <input id="occupancy" required type="number" v-model="room.occupancy" min="1">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="is-special-instance">Is Special</label>
                      <label class="switch">
                        <input id="is-special-instance" type="checkbox" v-model="room.is_special">
                        <span class="switch__slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-2">
                  <label for="is-special-instance">Is Multiple</label>
                  <label class="switch">
                    <input id="is-special-instance" type="checkbox" v-model="room.is_multiple">
                    <span class="switch__slider"></span>
                  </label>
                </div>
                <div class="col-md-10">
                  <div class="row" v-if="room.is_multiple && room.multiple_rooms_description && room.multiple_rooms_description.length > 0">
                    <div class="col-md-3" v-for="room_description in room.multiple_rooms_description" :key="room_description.id">
                      <label :for="`multiple_room_description_${ room_description.id }`">Description</label>
                      <input :id="`multiple_room_description_${ room_description.id }`" type="text" v-model="room_description.description">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <div v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled><span>Updating...</span></button>
              </div>
              <div v-else>
                <button type="submit" class="button" v-if="userRole == 1"><span>Update room</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="box mt-3">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3>Manage Availability</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form class="form" v-on:submit.prevent="updateAvailability">
          <div class="row p-3">
            <div class="col-md-3">
              <label for="start-date">Start Date</label>
              <input id="start-date" type="date" v-model="startDate" required class="m-0">
            </div>
            
            <div class="col-md-3">
              <label for="end-date">End Date</label>
              <input id="end-date" type="date" v-model="endDate" required class="m-0">
            </div>
            <div class="col-md-3">
              <label for="change-availability">Change availability</label>
                <v-select
                  v-model="availability.type"
                  :options="availabilityOptions"
                  label="name"
                  index="type"
                  class="m-0"
                  id="change-availability"
                />
            </div>
            <div class="col-md-3" v-if="availability && availability.type != 'stopSale' && availability.type != 'delete' && availability.type != 'resumeSale'">
              <label for="availability-count">Number</label>
              <input id="availability-count" type="number" v-model="availabilityCount" :required="(availability.type) ? true : false" class="m-0">
            </div>
          </div>
          <hr>
          <div class="row mt-2">
            <div class="col-md-12 m-3">
              <h3>Manage Availability Prices</h3>
            </div>
          </div>
          <div class="row p-3">
            <div class="col-md-3">
                <label for="prices_currency">Currency Type</label>
                <v-select
                    id="currency_type"
                    :options="currency_rates"
                    placeholder="Select Currency Type"
                    v-model="selected_price_currency"
                    @change="selectCurrency"
                    label="name"
                    required
                />
                <small class="text-danger"></small>
            </div>
            <div class="col-md-3">
                <label for="exchange_rate"> Exchange rate </label>
                <input id="exchange_rate" type="text" placeholder="Exchange rate" v-model="availability.exchange_rate">
            </div>
            <div class="col-md-3">
              <label for="change-availability">Price By</label>
              <v-select
                v-model="availability.price_by"
                :options="[
                  {
                    type: 'per_person',
                    label:'Per Person'
                  },
                  {
                    type: 'per_night',
                    label:'Per Night'
                  },
                ]"
                label="label"
                class="m-0"
                index="type"
                id="change-availability"
              />
            </div>
            <div class="col-md-3">
              <label for="availability-price">Accommodation Price</label>
              <input id="availability-price" type="number" v-model="availability.accomodation_price"  step="0.01" class="m-0">
            </div>
          </div>
          <div class="form-wrap form-submit">
            <div v-if="this.getLoadStatus">
              <button type="submit" class="button" disabled><span>Updating...</span></button>
            </div>
            <div v-else>
              <button type="submit" class="button" v-if="userRole == 1"><span>Update availability</span></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-md-12">
      <div class="box">
        <div class="table__header">
          <div class="box__header form--inline mx-auto">
              <template>
                <date-range-picker v-model="dateRange" format="mm/dd/yyyy" @update="checkOpenPicker" opens="center">
                    <!-- header slot-->
                    <div slot="header" slot-scope="header" class="slot-date-range-picker">
                      <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                    </div>
                    <!-- input slot (new slot syntax) -->
                    <template #input="picker">
                      {{ picker.startDate | date }} - {{ picker.endDate | date }}
                    </template>
                    <!-- date slot-->
                    <template #date="data">
                      <span class="small">{{ data.date | dateCell }}</span>
                    </template>
                    <!-- ranges (new slot syntax) -->
                    <template #ranges="ranges">
                        <div class="ranges">
                          <ul>
                            <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                              <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                            </li>
                          </ul>
                        </div>
                    </template>
                    <!-- footer slot -->
                    <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                        <div class="p-2">
                          <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                        </div>
                        <div style="margin-left: auto">
                          <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                        </div>
                    </div>
                </date-range-picker>
              </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box mt-4">
    <div class="table__header">
      <div class="box__header">
        <div class="row">
          <div class="col-md-8">
            <h3> Accomodation Prices  <ShowHideEye :showSection="showAccomodationPrices" @toggle="showAccomodationPrices = !showAccomodationPrices"/></h3>      
          </div>
          <div class="col-md-2" v-if="selectedPrices.length > 1">
            <a href="javascript:void(0)" class="button btn-warning p-2" @click="handlePriceDiscount">
              Manage Discount
            </a>
          </div>
          <div class="col-md-2" v-if="selectedPrices.length > 1">
            <a href="javascript:void(0)" class="button btn-primary p-2" @click="() => showClonePriceModal = true">
              Clone Price
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="showAccomodationPrices">
      <div class="col-md-12">
        <table class="table table-striped table-inverse table-responsive">
          <thead class="thead-inverse">
            <tr>
              <th>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="isSelectAll" @change="selectAllPrices">
                    Select All
                  </label>
                </div>
              </th>
              <th> Availability Date</th>
              <th> Currency </th>
              <th> Price By</th>
              <th> Price </th>
              <th> </th>
              <th> </th>
              <th> </th>
            </tr>
            </thead>
            <tbody>
              <template v-if="accomodationPrices.length > 0 ">
                <template v-for="price in accomodationPrices">
                  <tr :key="price.id">
                    <td scope="row"> 
                      <div class="form-check">
                        <label class="form-check-label">
                          <input type="checkbox" 
                              class="form-check-input" 
                              name="" 
                              id="" 
                              :checked="(selectedPrices.includes(price.id) ? true : false)"
                              @click="addIntoSelectedPrice(price.id)">
                        </label>
                      </div>
                    </td>
                    <td scope="row"> {{ price.room_availability_date | formatDate }}</td>
                    <td scope="row"> 
                      <template v-if="price.currency">
                        <ul>
                          <li>Currecncy : {{ price.currency.short_name }}</li>
                          <li>Exchange rate: {{ price.exchange_rate }}</li>
                        </ul>
                      </template>
                      <template v-else> -- </template>
                    </td>
                    <td scope="row">{{ price.price_type }}</td>
                    <td scope="row">
                      {{ price.currency.symbol }}{{ price.price | formatNumber }}
                    </td>
                    <td scope="row">
                      <a class="icon icon--more" @click="editAccomodationPrice(price)">Edit</a>
                    </td>
                    <td scope="row">
                      <a class="icon icon--delete" @click="deleteAccomodationPrice(price.id)">Delete</a>
                    </td>
                    <td scope="row">
                      <a href="javascript:void(0)" class="button btn-warning p-2" @click="handlePriceDiscount(price)">
                        Discount
                      </a>
                    </td>
                  </tr>
                  <tr :key="price.id + '-accommodation_price'" v-if="selectedAccomodationPriceId == price.id">
                    <td scope="row"></td>
                    <td scope="row"> 
                      <input id="end-date" type="date" v-model="selectedAccomodationPrice.room_availability_date" required class="m-0">
                    </td>
                    <td scope="row">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <select class="form-control" name="" :id="`edit_currency_type_${ selectedAccomodationPrice.id }`" v-model="selected_edit_price_currency_id" @change="editAccomodationPriceCurrency">
                              <option value="">Select</option>
                              <option v-for="rates in currency_rates" :key="rates.currency_id" 
                                :value="rates.currency_id">
                                {{ rates.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-md-12">
                          <input id="exchange_rate" type="text" placeholder="Exchange rate" v-model="selectedAccomodationPrice.exchange_rate">
                        </div>
                      </div>
                    </td>
                    <td scope="row">
                      <v-select
                        v-model="selectedAccomodationPrice.price_type"
                        :options="[
                          {
                            type: 'per_person',
                            label:'Per Person'
                          },
                          {
                            type: 'per_night',
                            label:'Per Night'
                          },
                        ]"
                        label="label"
                        class="m-0"
                        index="type"
                        id="change-availability"
                      />
                    </td>
                    <td scope="row"> 
                      <input id="availability-price" type="number" v-model="selectedAccomodationPrice.price"  step="0.01" class="m-0">
                    </td>
                    <td scope="row">
                      <button class="button" @click="updateSelectedPrices">
                        <span>Save</span>
                      </button> <br/> <br/>
                      <button class="button" @click="selectedAccomodationPrice = {}; selectedAccomodationPriceId=null" >
                        <span>Clear</span>
                      </button> <br/>
                    </td>
                    <td scope="row"> 
                      
                    </td>
                  </tr>
              </template>
              </template>
              <template v-else>
                <tr>
                  <td scope="row" colspan="8" class="text-center"> No Data Found</td>
                </tr>
              </template>
            </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="box">
    <div class="row p-3">
      <div class="col-md-12">
        <h3> Accomodation Availability <ShowHideEye :showSection="showAccomodationAvailability" @toggle="showAccomodationAvailability = !showAccomodationAvailability"/> </h3>
      </div>
    </div>
    <div class="row" v-if="showAccomodationAvailability">
      <div class="col-md-12">
        <vdtnet-table
          ref="table"
          :fields="fields"
          :opts="options"
          :key="tableKey"
        >
        </vdtnet-table>
      </div>
    </div>
  </div>

  <div class="modal__bg" v-if="showAccomodationPriceDiscountModal == true"></div>
  <div class="modal" v-if="showAccomodationPriceDiscountModal == true">
    <AccomodationPriceDiscount :accomodationPriceID="selectedPriceForDiscount" 
        :multiple_price_ids="selectedPrices"
        @handleDiscountModal="handleDiscountModal"/>
    <button type="button" class="icon icon--unlink" v-on:click="showAccomodationPriceDiscountModal = false">Close</button>
  </div>
  <div class="modal__bg" v-if="showAccomodationPriceDiscountModal == true"></div>

  <div class="modal__bg" v-if="showClonePriceModal == true"></div>
  <div class="modal" v-if="showClonePriceModal == true" style="height: 300px;width: 800px;">
    <ClonePriceModalFields :accomodation_room_id="Number($route.params.id)" :multiple_price_ids="selectedPrices"/>
    <button type="button" class="icon icon--unlink" v-on:click="showClonePriceModal = false">Close</button>
  </div>
  <div class="modal__bg" v-if="showClonePriceModal == true"></div>

</div>

</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment';
import "datatables.net";
import VdtnetTable from "vue-datatables-net";
import ShowHideEye from "../components/ShowHideEye.vue";
import AccomodationPriceDiscount from "../components/Accomodation/AccomodationPriceDiscount.vue"
import ClonePriceModalFields from "../components/Accomodation/ClonePriceModalFields.vue"

export default {
  name: 'AccommodationRoomEdit',
  components: {
    VdtnetTable,
    ShowHideEye,
    AccomodationPriceDiscount,
    ClonePriceModalFields
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    },
    options() {
      return {
        ajax: {
          url: this.$api + `accommodation/room/availability/${this.$route.params.id}/table?startDate=${this.dateRange.startDate}&endDate=${this.dateRange.endDate}`,
          headers: {
            Accept: "application/json",
            Authorization: localStorage.getItem("token")
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: "rtlip",
        autoWidth: false,
        lengthMenu: [[25, 50, 100, 500, -1], [25, 50, 100, 500, "All"]],
        pageLength: 25
      }
    }
  },
  data () {
    return {
      room: {},
      currency_rates:[],
      accomodationPrices: [],
      startDate: null,
      endDate: null,
      availability: {
        selected_currency:null,
        exchange_rate:0,
        price_by: null,
        accomodation_price: 0,
        bookingstartDate : '',
        bookingendDate : '',
      },
      availabilityCount: null,
      availabilityOptions: [
        {
          name: 'Change Number of room set upto' ,
          type: 'updateExisting'
        },
        {
          name: 'Change Number of room set by' ,
          type: 'incrementAvailability'
        },
        {
          name: 'Change Number of room set as' ,
          type: 'skipExistingAndCreate'
        },
        {
          name: 'Stop Sale' ,
          type: 'stopSale'
        },
        {
          name: 'Resume Sale' ,
          type: 'resumeSale'
        },
         {
          name: 'Delete Availability' ,
          type: 'delete'
        }
      ],
      fields: {
        availability_date: { label: "Date", render: ( data ) => {
          return moment(data).format("DD MMMM YYYY");
        }},
        availability: { label: "Availability" },
        remaining_availability: {label: "Remaining Availability"},
        confirmed_locked_availability: {label: "Confirmed"},
        locked_availability: {label: "Unconfirmed"},
        stop_sell: { label: "Stop Sell" },
      },
      dateRange: {
        startDate : '',
        endDate : '',
      },
      tableKey: 0, // Key attribute to force re-render of the table,
      selected_price_currency: {},
      showAccomodationPrices:false,
      showAccomodationAvailability:true,
      selectedAccomodationPriceId:null,
      selectedAccomodationPrice: {},
      isSelectAll: null,
      selectedPrices: [],
      selectedPriceForDiscount: null,
      showAccomodationPriceDiscountModal: false,
      selected_edit_price_currency_id: null,
      showClonePriceModal:false,
    }
  },
  created () {
    const startDate = moment().format('YYYY-MM-DD');
    const endDate = moment().endOf('month').format('YYYY-MM-DD');
    this.dateRange.startDate = startDate;
    this.dateRange.endDate = endDate;
    this.getCurrencyExchangeRate()
    this.getAccommodationRoom()
    this.getAccomodationPrices()
  },
  filters: {
    dateCell (value) {
      let dt = new Date(value)

      return dt.getDate()
    },
    date (val) {
      return val ? val.toDateString() : ''
    }
  },
  watch: {
    '$route': 'getAccommodationRoom',
    'room.is_multiple': function (newVal) {
      if (newVal) {
        const roomDescriptions = this.parseRoomDescriptions(this.room.name);
        this.room.multiple_rooms_description = roomDescriptions;
      } else {
        this.room.multiple_rooms_description = null;
      }
    }
  },
  methods: {
    parseRoomDescriptions(name) {
      const roomDescriptions = [];
      
      // Check if the name contains a slash
      if (name.includes('/')) {
        // Split by slash to get all room types
        const parts = name.split('/');
        
        // Extract only the first word from each part (the room type)
        parts.forEach((part, index) => {
          const trimmed = part.trim();
          // For the last part, extract only the first word before any space
          const roomType = index === parts.length - 1 
            ? trimmed.split(/\s+/)[0] 
            : trimmed;
          roomDescriptions.push({
            id: Math.random().toString(36).substring(2,7),
            description: roomType
          });
        });
      }

      return roomDescriptions;
    },
    getCurrencyExchangeRate() {
      fetch(this.$api + 'currency-exchange/get-current-list', {
          headers:{
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
      })
      .then(res => res.json())
      .then(response => {
          this.errors = response.errors
          if(response.status) {
              this.currency_rates = response.data
          }
      });
    },
    getAccommodationRoom () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/room/' + this.$route.params.id, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.room = response.data[0];
        // this.accomodationPrices = this.room.accomodation_price
      })
    },
    updateAvailability() {
      if(this.startDate > this.endDate){
        this.$notify({
          type: 'error',
          title: 'End date should be greater than the start date'
        });
        return;
      }else if(!this.availability) {
        this.$notify({
          type: 'error',
          title: 'Change availability field is required'
        });
        return;
      }else if(this.availability.type === 'delete') {
        this.$notify({
          type: 'warn',
          title: 'Deleting room availability is not available at the moment. Please be patient. It will be functional soon.'
        });
        return;
      }else {
        const postData = {
          'start_date': this.startDate,
          'end_date': this.endDate,
          'type': this.availability.type,
          'availability': this.availabilityCount,
          'booking_start_date' : this.availability.bookingstartDate,
          'booking_end_date' : this.availability.bookingendDate,
          'selected_currency':this.availability.selected_currency,
          'exchange_rate':this.availability.exchange_rate,
          'price_by': this.availability.price_by,
          'price' : this.availability.accomodation_price,
        }
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'accommodation/room/availability/' + this.$route.params.id, {
          method: 'POST',
          body: JSON.stringify(postData),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$refs.table.reload();
            this.startDate = null;
            this.endDate = null;
            this.availability = {
              selected_currency:null,
              exchange_rate:0,
              price_by: null,
              accomodation_price: 0,
              bookingstartDate : '',
              bookingendDate : '',
            };
            this.availabilityCount = null;
            this.tableKey++;
            this.getAccomodationPrices()
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus');
        });
      }
    },
    checkOpenPicker() {
      
      const ajaxUrl = this.$api + `accommodation/room/availability/${this.$route.params.id}/table`

      const queryString = new URLSearchParams();
      queryString.set('startDate',  moment(this.dateRange.startDate).format('YYYY-MM-DD'));
      queryString.set('endDate',  moment(this.dateRange.endDate).format('YYYY-MM-DD'));

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;

      this.getAccomodationPrices()
    },
    updateRoom () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/rooms/' + this.$route.params.id + '/update', {
        method: 'post',
        body: JSON.stringify(this.room),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.newRoom = {};
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.getAccommodationRoom()
        this.$store.dispatch('setLoadStatus')
      })
    },
    getAccomodationPrices() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/room/get-availability/' + this.$route.params.id + '/prices', {
        method: 'post',
        body: JSON.stringify({
          start_date: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
          end_date: moment(this.dateRange.endDate).format('YYYY-MM-DD')
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.status) {
          this.accomodationPrices = response.data
          if (this.accomodationPrices.length > 0 ) {
            this.showAccomodationPrices = true
          } else {
            this.showAccomodationPrices = false
          }
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    editAccomodationPrice(editRecord) {
      this.selectedAccomodationPriceId = editRecord.id
      this.selectedAccomodationPrice = editRecord;
      this.selected_edit_price_currency_id = editRecord.currency_id
    },
    updateSelectedPrices () {
      if (this.selectedAccomodationPrice) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'accommodation/room/update-availability/' + this.$route.params.id + '/prices', {
          method: 'post',
          body: JSON.stringify({
            price_id: this.selectedAccomodationPriceId,
            ...this.selectedAccomodationPrice
          }),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.status) {
            this.$notify({
              type: 'success',
              title: response.message
            });

            this.selectedAccomodationPriceId = null
            this.selectedAccomodationPrice = {};
            this.getAccomodationPrices()
          
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
         
          this.$store.dispatch('setLoadStatus')
        })
      }
    },
    deleteAccomodationPrice(price_id) {
      this.$dialog
          .confirm(`Are you sure you want to delete Accomodation Price ?`)
          .then(() => {
              this.$store.dispatch('setLoadStatus')
              fetch(`${this.$api}accommodation/room/delete-availability/${this.$route.params.id}/prices`, {
                  method: 'POST',
                  body: JSON.stringify({
                    price_id
                  }),
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'Authorization': localStorage.getItem('token')
                  }
              })
              .then(res => res.json())
              .then(response => {
                  this.errors = response.errors
                  if(response.status) {
                      this.$notify({
                        type: 'success',
                        title: response.message
                      });
                      this.getAccomodationPrices()
                  } else if (response.errors) {
                      this.$notify({
                        type: 'error',
                        title: response.message
                      });
                  } else {
                      this.$notify({
                        type: 'error',
                        title: response.Error
                      });
                  }
                  this.$store.dispatch('setLoadStatus')
              });
          }).catch((error) => {
              console.log(error);
              // this.$store.dispatch('setLoadStatus')
              console.log('Clicked on cancel');
          });
    },
    selectAllPrices() {
      if (this.isSelectAll) {
        let price_ids = this.accomodationPrices.map(element => element.id)
        this.selectedPrices = price_ids 
      } else {
        this.selectedPrices = [] 
      }
    },
    addIntoSelectedPrice(price_id) {
      this.selectedPrices.push(price_id)
    },
    handlePriceDiscount(price_object = null) {
      if (price_object != null) {
        this.selectedPriceForDiscount = price_object
        this.showAccomodationPriceDiscountModal = true
      } else {
        if (this.selectedPrices.length > 1) {
          this.showAccomodationPriceDiscountModal = true
        }
      }
    },
    handleDiscountModal(handle_value) {
      this.selectedPrices = []
      this.showAccomodationPriceDiscountModal = handle_value
    },
    selectCurrency() {
      if (this.selected_price_currency) {
        this.availability.exchange_rate = this.selected_price_currency.exchange_rate;
        this.availability.selected_currency = this.selected_price_currency.currency_id
      } else {
        this.availability.exchange_rate = null;
        this.availability.selected_currency = null;
        
      }
    },
    editAccomodationPriceCurrency() {
      if (this.selectedAccomodationPrice) { 
        let selected_currency = this.currency_rates.find(element => element.currency_id == this.selected_edit_price_currency_id)
        console.log(selected_currency);
        if (selected_currency) {
          this.selectedAccomodationPrice.currency_id = selected_currency.currency_id
          this.selectedAccomodationPrice.exchange_rate = selected_currency.exchange_rate
        }
      }
    }
  }
}
</script>
<style scoped>
.slot-date-range-picker {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.slot-date-range-picker h3 {
  font-size: 1.0625rem;
}

.text-black {
  color: #000;
}
</style>
